<script lang="ts">
    import { config } from 'rxjs'
    import type { IChatSetting } from '../lib/types'
    import ChatConfig from './ChatConfig.svelte'

    export let configs: IChatSetting
    export let addToPreviewList, removeFromPreviewList, save, removeChatSetting
    export let previewList = []
    let opened = []

    $: previewShowing = (config: IChatSetting) => {
        return previewList.includes(config)
    }

    function toggleOpen(index) {
        if (!opened[index]) {
            opened[index] = true
        } else {
            opened[index] = false
        }
    }

    function togglePreview(config: IChatSetting) {
        if (previewList.includes(config)) {
            removeFromPreviewList(config)
        } else {
            addToPreviewList(config)
        }
    }
</script>

<div class="bg-white shadow sm:rounded-md">
    <ul>
        {#each Object.values(configs) as config, index}
            <li>
                <div
                    on:click={() => {
                        toggleOpen(index)
                    }}
                    class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out">
                    <div class="flex items-center px-4 py-4 sm:px-6">
                        <div class="min-w-0 flex-1 flex items-center">
                            <div
                                class="min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4">
                                <div>
                                    <div
                                        class=" text-base leading-5 font-medium">
                                        Messages Per Minute:
                                        {config.messagesPerMinute}
                                    </div>
                                    <div
                                        class="mt-2 flex items-center text-sm leading-5">
                                        <svg
                                            class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor">
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                        </svg>
                                        <span
                                            style={`color: ${config.color}; font-size: ${config.fontSize}px; font-family: ${config.family}; text-transform: ${config.upperCase ? 'uppercase' : 'none'}; font-weight: ${config.fontWeight}; font-style: ${config.fontStyle}; text-decoration: ${config.underline ? 'underline' : 'none'}; `}
                                            class="truncate block">Random_Twitch_Username</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-row">
                            <div title="Unsaved Config">
                                {#if !config._id}
                                    <svg
                                        class="h-5 w-5 mr-3 text-orange-500"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor">
                                        <path
                                            fill-rule="evenodd"
                                            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                                            clip-rule="evenodd" />
                                    </svg>
                                {/if}
                            </div>
                            <div
                                on:click|preventDefault|stopPropagation={() => togglePreview(config)}>
                                {#if previewShowing(config)}
                                    <svg
                                        class="h-5 w-5 mr-3 text-indigo-800"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor">
                                        <path
                                            d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                        <path
                                            fill-rule="evenodd"
                                            d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                                            clip-rule="evenodd" />
                                    </svg>
                                {:else}
                                    <svg
                                        class="h-5 w-5 mr-3 text-gray-800"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor">
                                        <path
                                            fill-rule="evenodd"
                                            d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z"
                                            clip-rule="evenodd" />
                                        <path
                                            d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" />
                                    </svg>
                                {/if}
                            </div>
                            <div
                                on:click|preventDefault|stopPropagation={() => removeChatSetting(config)}>
                                <svg
                                    class="h-5 w-5 mr-3 text-red-800"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor">
                                    <path
                                        fill-rule="evenodd"
                                        d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                        clip-rule="evenodd" />
                                </svg>
                            </div>
                            <!-- Heroicon name: chevron-right -->
                            <svg
                                class="h-5 w-5 text-gray-400 {opened[index] ? 'rotate-90' : 'rotate-0'} transform transition duration-200"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor">
                                <path
                                    fill-rule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                        </div>
                    </div>
                </div>
            </li>
            {#if opened[index]}
                <div class="flex bg-gray-100">
                    <ChatConfig {save} settings={config} />
                </div>
            {/if}
        {/each}
    </ul>
</div>

<style>
</style>
